'use client';

import { FinalScreen } from '@/app/[lang]/(main)/components/shared/scenarios/common/Screens/FinalScreen';

type Props = {
  onClose: () => void;
  productId: string;
};

export const AfterPurchaseWithCoin: React.FC<Props> = ({ onClose, productId }) => {
  return (
    <>
      <FinalScreen onClose={onClose} productId={productId} />
    </>
  );
};
